import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect, useState } from 'react';
import Link from '../Link';
import request from '../../service/request';
import { TRADEHOUSE_SEARCH_NEW, RENTHOUSE_SEARCH_NEW, NEWHOUSE_SEARCH_NEW, SEARCH_ADD_HOT_WORD } from '../../service/api';
import format from '../../utils/format';
import s from './index.less'

export default function Search(props) {
    useStyles(s);

    const [storageDate, setStorageDate] = useState({});
    const navInfo = {
        list: ['首页', '二手房', '租房', '新房', '保租房'],
        link: ['/', '/ershoufang/list', '/zufang/list', '/xinfang/list', '/baozf/list'],
        detailLink: ['/', '/ershoufang/detail', '/zufang/detail', '/xinfang/detail', '/baozf/detail']
    };

    const [searchInfo, setSearchInfo] = useState({
        dataList: [],
        isShow: false,
        selectIndex: -1,
        // searchText: (props.searchhousename || '') as string,
        clearHistory: false,
        isChinese: false
    });

    const [searchText, setSearchText] = useState((props.searchhousename || ''));

    useEffect(() => {
        document.addEventListener("click", otherDomClick);
        setStorageDate(JSON.parse(localStorage.getItem('search_history_list') || JSON.stringify({ 0: [], 1: [], 2: [] })));
    }, []);

    useEffect(() => {
        if (searchText != props.searchhousename && searchText === '' && !props.isdetail) {
            let link = navInfo.link[props.businesstype] + (searchText ? `?housename=${searchText}` : '');
            window.location.href = link;
        }
        if (searchText && searchInfo.clearHistory) {
            getList(searchText);
        }
    }, [searchText, setSearchText]);

    useEffect(() => {
        // setSearchInfo({
        //     ...searchInfo,
        //     searchText: (props.searchhousename || '') as string
        // });
        // 失去焦点
        // const input = document.querySelector('#search-input');
        // input.blur();
    }, [props.searchhousename]);

    const otherDomClick = (e) => {
        if (e.target.className !== 'search-input' && e.target.className !== 'ellipsis'
            && e.target.className !== 'info' && e.target.className !== 'clear-history') {
            const input = document.querySelector('#search-input');
            setSearchInfo({
                ...searchInfo,
                clearHistory: false,
                isShow: false
            });
            setSearchText(e.target.className == 'iconfont icon-del' ? '' : (input ? input.value : ''));
        }
    };

    const setIsShowFun = (flag, keyWord) => {
        if (keyWord || keyWord === '') {
            setSearchText(keyWord);

            setSearchInfo({
                ...searchInfo,
                selectIndex: keyWord === '' ? -1 : searchInfo.selectIndex,
                clearHistory: keyWord !== '',
                isShow: flag
            });
        } else {
            setSearchText(searchText);
            setSearchInfo({
                ...searchInfo,
                dataList: searchText ? [] : ((storageDate[props.businesstype - 1] && storageDate[props.businesstype - 1].length) ? storageDate[props.businesstype - 1] : searchInfo.dataList),
                clearHistory: searchText ? true : (!!(storageDate[props.businesstype - 1] && storageDate[props.businesstype - 1].length)),
                isShow: flag
            });
        }
    };

    const inputKeyDownFun = (e) => {
        const newSearch = { ...searchInfo };
        if (e.keyCode === 40) {// 下键
            if (newSearch.selectIndex === searchInfo.dataList.length - 1) return;
            newSearch.selectIndex++;
            setSearchInfo({
                ...searchInfo,
                selectIndex: newSearch.selectIndex,
            });
        } else if (e.keyCode === 38) {// 上键
            if (newSearch.selectIndex === 0) return;
            newSearch.selectIndex--;
            setSearchInfo({
                ...searchInfo,
                selectIndex: newSearch.selectIndex,
            });
        } else if (e.keyCode === 13) { //回车
            goLink(newSearch.selectIndex, true);
        }
    };

    const inputChangeFun = (e) => {
        if (e.target.value.replace(/\s+/g, '') === '') {
            setIsShowFun(false, '');
        } else {
            setIsShowFun(false, e.target.value);
        }
    };

    const brightKeyword = (val, keyWord) => {
        const valKey = keyWord.replace(/\s+/g, '');
        if (!val) {
            return '';
        } else if (val.indexOf(valKey) !== -1) {
            return val.replace(valKey, `<strong style="color: #F2282A;font-weight: normal">${valKey}</strong>`);
        } else {
            return val;
        }
    };

    // 处理房源数量展示
    const handleHouseNumber = (houseNumber, houseType) => {
        if (!houseNumber || houseNumber === 0) {
            return '';
        } else if (houseType === '租房') {
            return `在租${houseNumber}套`;
        } else {
            return `在售${houseNumber}套`;
        }
    };

    const goLink = (index, isEnterKey = false, isSearchMap = false) => {
        let houseName = '';
        let isNewHouseDetail = false;
        let houseId = '';
        if (searchInfo.dataList[index] && searchInfo.dataList[index].newHouseName) {
            houseName = index !== null && index > -1 ? searchInfo.dataList[index].newHouseName : searchText;
            isNewHouseDetail = true;
            houseId = searchInfo.dataList[index].newHouseId ? searchInfo.dataList[index].newHouseId : '';
        } else {
            houseName = index !== null && index > -1 ? searchInfo.dataList[index].estateName || searchInfo.dataList[index].tradeAreaName || searchInfo.dataList[index].countryAreaName || searchInfo.dataList[index].houseName : searchText;
        }

        const address = index !== null && index > -1 ? searchInfo.dataList[index].address : '';
        setSearchText(houseName);
        setSearchInfo({
            ...searchInfo,
            isShow: false,
            selectIndex: index || -1,
        });
        if (houseName) cleanHistory(houseName, address);
        // 判断当前搜索是新房/租房/二手房
        let query = ""
        if (!isEnterKey) {//是否回车
            const { searchType, tradeAreaId, estateId, estateName } = searchInfo.dataList[index]
            if (isSearchMap) {//是否点击搜索时的匹配框
                switch (props.businesstype) {
                    case 1: // '二手房'
                        if (searchType == 1) { // 商圈
                            query += `tradeAreaId=${tradeAreaId}`
                        } else { // 小区
                            query += `locationEstateId=${estateId}&searchEstateName=${estateName}`
                        }
                        break;
                    case 2: // '租房'
                        if (searchType == 1) { // 商圈
                            query += `tradeAreaId=${tradeAreaId}`
                        } else { // 小区
                            query += `estateId=${estateId}&searchEstateName=${estateName}`
                        }
                        break;
                    case 3: // '新房'
                        query += `tradeAreaId=${tradeAreaId}`
                        break;
                    default:
                        break;
                }
            } else {
                query += `searchEsText=${houseName}&isEsSearch=${true}`
            }
        } else {
            query += `searchEsText=${houseName}&isEsSearch=${true}`
        }
        let link = '';
        if (isNewHouseDetail) {
            link = navInfo.detailLink[props.businesstype] + (houseId ? `?id=${houseId}` : '');
            addHotWord(houseName);
        } else {
            link = navInfo.link[props.businesstype] + (houseName ? `?housename=${houseName}&${query.length > 0 ? query : ''}` : '');
        }
        if (props.isdetail) {
            window.open('_blank').location = link;
        } else {
            window.location.href = link;
        }

        //  return false;
    };

    const cleanHistory = (houseName, address) => {
        const newObj = { ...storageDate };
        const item = {
            houseName,
            address
        };
        const i = newObj[props.businesstype - 1].findIndex((items) => items.houseName === houseName);
        if (i >= 0) {
            newObj[props.businesstype - 1].splice(i, 1);
        }
        newObj[props.businesstype - 1].unshift(item);
        localStorage.setItem('search_history_list', JSON.stringify(newObj));
    }

    const delHistory = () => {
        const newObj = { ...storageDate };
        newObj[props.businesstype - 1] = [];
        localStorage.setItem('search_history_list', JSON.stringify(newObj));
        setStorageDate(newObj);
    }

    const pageTempl = () => {

        return (
            <>
                <div className="bread-box">
                    <Link to="/" target="_blank">首页</Link><span>&#65125;</span>
                    {props.isdetail ? <Link to={navInfo.link[props.businesstype]}>{navInfo.list[props.businesstype]}</Link> : navInfo.list[props.businesstype]}
                    {props.isdetail && props.houseType ? <Link to={`${navInfo.link[props.businesstype]}?houseType=${props.houseType}`}><span>&#65125;</span>{props.houseType === 1 ? '必选好房' : (props.houseType === 2 ? '店长力荐' : null)}</Link> : null}
                    {props.isdetail ? (props.isnews || props.isalbums || props.isframe ?
                        <><span>&#65125;</span>
                            <Link to={props.houseid ? `${navInfo.detailLink[props.businesstype]}?id=${props.houseid}` : navInfo.detailLink[props.businesstype]}>{props.housename}</Link>
                        </> : <><span>&#65125;</span>{props.housename}</>) : null}
                    {props.isnews ? <><span>&#65125;</span>楼盘动态</> : null}

                    {props.isalbums ? <><span>&#65125;</span>楼盘相册</> : null}

                    {props.isframe ? <><span>&#65125;</span>户型介绍</> : null}
                </div>
                {props.hideSearch ? <></> : <>
                    <div className="search-box">
                        <div className={props.isdetail ? "search-form page-detail" : "search-form page-search-list"}>
                            <input type="text" id="search-input" className="search-input"
                                placeholder="请输入区域、商圈或小区名开始找房"
                                autoComplete="off"
                                value={searchText}
                                onChange={(e) => inputChangeFun(e)}
                                onFocus={() => setIsShowFun(true)}
                                onKeyDown={(e) => inputKeyDownFun(e)}
                            />
                            {searchInfo.isShow && searchInfo.dataList.length ?
                                <div className={searchInfo.clearHistory ? 'other width_max' : 'other width_min'}>
                                    {searchInfo.clearHistory ?
                                        <>
                                            <div className="clear-history">历史记录<i className="iconfont icon-del-history" onClick={() => delHistory()}>&#xe7a5;</i></div>
                                            {searchInfo.dataList.map((items, index) => {
                                                if (index > 9 && searchInfo.clearHistory) return null
                                                return (
                                                    <div key={index}
                                                        className={searchInfo.selectIndex === index ? 'active ellipsis' : 'ellipsis'}
                                                        onClick={() => goLink(index)}>
                                                        <span className="info ellipsis"
                                                            dangerouslySetInnerHTML={{ __html: brightKeyword(items.estateName || items.tradeAreaName || items.countryAreaName || items.houseName, searchText) }} />
                                                    </div>)
                                            })}
                                        </>
                                        :
                                        <>
                                            {searchInfo.dataList.map((items, index) => {
                                                if (index > 9 && searchInfo.clearHistory) return null
                                                return (navInfo.list[props.businesstype] === '新房'
                                                    ? <div key={index}
                                                        className={searchInfo.selectIndex === index ? 'active ellipsis' : 'ellipsis'}
                                                        onClick={() => goLink(index, false, true)}>
                                                        {items.searchType == 1 ? <span className="tag tagPad first"
                                                            dangerouslySetInnerHTML={{ __html: '商圈' }} /> :
                                                            <> {items.searchType ?
                                                                <span className={items.searchType ? 'tag tagPad first' : 'tag first'}
                                                                    dangerouslySetInnerHTML={{ __html: format.formatHouseKeeperType(items.houseKeeperType) }} />
                                                                : <span className={items.searchType ? 'tag tagPad first' : 'tag first'}
                                                                    dangerouslySetInnerHTML={{ __html: '' }} />
                                                            }
                                                            </>
                                                        }
                                                        {/* 搜索结果名称-商圈名称 */}
                                                        <span className="info ellipsis"
                                                            dangerouslySetInnerHTML={{ __html: brightKeyword(items.newHouseName || items.houseName || items.tradeAreaName, searchText) }} />

                                                        {/* 除商圈外 区域  吴中-万达  */}
                                                        {
                                                            items.searchType != 1 && !props.isdetail ? <span className="area"
                                                                dangerouslySetInnerHTML={{ __html: `${items.countryAreaName || ''}${items.countryAreaName && items.tradeAreaName ? '-' : ''}${items.tradeAreaName || ''}` }} /> : <></>
                                                        }

                                                        {props.isdetail ? <></> : <>
                                                            {items.searchType == 1 ? <span className="number last"
                                                                dangerouslySetInnerHTML={{ __html: handleHouseNumber(items.houseNumber, '新房') }} /> :
                                                                <> {items.searchType ?
                                                                    <>{items.salePrice ?
                                                                        <span className="number last"
                                                                            dangerouslySetInnerHTML={{ __html: `${format.formatNewHouseStatus(items.newHouseStatus)} ${items.salePrice || 0}元/㎡起` }} /> :
                                                                        <span className="number last"
                                                                            dangerouslySetInnerHTML={{ __html: `${format.formatNewHouseStatus(items.newHouseStatus)}  价格待定` }} />
                                                                    }
                                                                    </>
                                                                    : <></>
                                                                }
                                                                </>
                                                            }
                                                        </>
                                                        }

                                                    </div>
                                                    : <div key={index}
                                                        className={searchInfo.selectIndex === index ? 'active ellipsis' : 'ellipsis'}
                                                        onClick={() => goLink(index, false, true)}>
                                                        <span className={items.searchType ? 'tag tagPad first' : 'tag first'}
                                                            dangerouslySetInnerHTML={{ __html: format.formatSearchType(items.searchType) }} />
                                                        <span className="info ellipsis"
                                                            dangerouslySetInnerHTML={{ __html: brightKeyword(items.estateName || items.tradeAreaName || items.countryAreaName || items.houseName, searchText) }} />
                                                        {!props.isdetail ? <>
                                                            <div className="information">
                                                                {navInfo.list[props.businesstype] === '二手房'
                                                                    ? items.averagePrice ? <span className="price" dangerouslySetInnerHTML={{ __html: `${items.averagePrice}元/㎡起` }} />
                                                                        : <></>
                                                                    : <></>
                                                                }
                                                                {navInfo.list[props.businesstype] === '租房'
                                                                    ? <span className="number last"
                                                                        dangerouslySetInnerHTML={{ __html: handleHouseNumber(items.houseNumber, '租房') }} />
                                                                    :
                                                                    <span className="number last"
                                                                        dangerouslySetInnerHTML={{ __html: handleHouseNumber(items.houseNumber, '二手房') }} />
                                                                }
                                                            </div>
                                                        </> : <></>}

                                                    </div>)
                                            })}
                                        </>
                                    }
                                </div> : null}
                            {searchText ? <span className="del-btn"
                                onClick={() => {
                                    setSearchText('');
                                    if (!props.isdetail) {
                                        window.location.href = navInfo.link[props.businesstype];
                                        // return false;
                                    }
                                }}><i className="iconfont icon-del">&#xe787;</i></span> : null}
                            <span className="search-btn" onClick={() => goLink(-1, true)}><i className="iconfont icon-look">&#xe77e;</i></span>
                        </div>
                    </div>
                </>}
            </>
        )
    };

    const getList = (keyWord) => {
        request.POST({
            url: [TRADEHOUSE_SEARCH_NEW, RENTHOUSE_SEARCH_NEW, NEWHOUSE_SEARCH_NEW][props.businesstype - 1],
            params: {
                text: keyWord
            }
        }).then((res) => {
            if (res.data) {
                setSearchInfo({
                    ...searchInfo,
                    dataList: res.data,
                    // searchText: keyWord,
                    isShow: true,
                    clearHistory: false
                });
            }

        }).catch((error) => {
            console.log(error, 'error');
        });

    };

    // 热词添加接口
    const addHotWord = (key) => {
        request.POST({
            url: SEARCH_ADD_HOT_WORD,
            params: {
                keyWord: key
            }
        }).catch((error) => {
            console.log(error, 'error');
        })
    }

    return (
        props.isdetail ?
            <div className="detail-header">
                <div className="bread-search">
                    {pageTempl()}
                </div>
            </div> : pageTempl()
    )
}
